import React, {FC} from 'react'
import { TablesContactenos } from './Contactenos/TablesContactenos'


const Contactenos: FC = () => {
  return (
    <>
      <TablesContactenos className='mb-5 mb-xl-8' />
    </>
  )
}

export {Contactenos}
